import {
  Download,
  LogIn,
  MoreVertical,
  PlugZap,
} from 'lucide-react'
import { testIds } from '@/lib/test-ids'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  SidebarShellMenuItems,
  useShellMenuHold,
} from '@/components/layout/left-sidebar.panel-menu'
import { QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS } from '@/lib/menu-chrome'
import { cn } from '@/lib/utils'

export function DriveOptionsMenu({
  connected,
  onConnect,
  onImportFromDrive,
  openTabsVisible,
  onOpenTabsVisibleChange,
  collapsed,
  onCollapseSidebar,
}: {
  connected: boolean
  onConnect: () => void
  onImportFromDrive?: () => void
  openTabsVisible: boolean
  onOpenTabsVisibleChange: (visible: boolean) => void
  collapsed: boolean
  onCollapseSidebar: () => void
}) {
  const onMenuOpenChange = useShellMenuHold()
  return (
    <DropdownMenu onOpenChange={onMenuOpenChange}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            'flex h-6 shrink-0 items-center gap-1 rounded px-1',
            'text-sidebar-foreground/60 hover:bg-sidebar-accent/60 hover:text-sidebar-foreground',
          )}
          title="Google Drive options"
          aria-label="Google Drive options"
        >
          <MoreVertical className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS}>
        {connected && onImportFromDrive ? (
          <DropdownMenuItem
            onSelect={onImportFromDrive}
            data-testid={testIds.driveSidebar.importFromDriveMenuItem}
          >
            <Download className="mr-2 h-4 w-4" />
            Import from Drive
          </DropdownMenuItem>
        ) : null}
        {connected ? (
          <DropdownMenuItem onSelect={onConnect}>
            <PlugZap className="mr-2 h-4 w-4" />
            Reconnect / Re-authorize
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onSelect={onConnect}>
            <LogIn className="mr-2 h-4 w-4" />
            Connect Google Drive
          </DropdownMenuItem>
        )}
        <SidebarShellMenuItems
          openTabsVisible={openTabsVisible}
          onOpenTabsVisibleChange={onOpenTabsVisibleChange}
          collapsed={collapsed}
          onCollapseSidebar={onCollapseSidebar}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
